import type { GetCustomersOverviewsNewResponse } from '@vy/api-definition';
import { fromNullToUndefined, vySerialize } from '@vy/utils';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { useTableSorting } from '../../../hooks/use-table-sorting';
import { useFiltersParam } from '../../../pages/customers/CustomersPage/customers-page-hooks/use-filters-param';
import { useQueryInputParams } from '../../../pages/customers/CustomersPage/customers-page-hooks/use-query-input-param';
import { queryKeys } from '../../../services/query-key/query-keys';
import { customersOverviewsNewQuery } from './use-customers-overviews-new';

const PAGE = 0;
const PAGE_SIZE = 100000;

export function useNonPagedCustomersOverviewsFromParams(
  options?: UseMutationOptions<GetCustomersOverviewsNewResponse, unknown>,
) {
  const [search] = useQueryInputParams();
  const [filters] = useFiltersParam();
  const { currentSortModel } = useTableSorting();

  const filtersForApi = filters?.map((filter) => {
    const { id: _id, ...rest } = filter as typeof filter & { id?: string };
    return rest;
  });

  const payload = {
    search: fromNullToUndefined(search),
    customerFilters: vySerialize(filtersForApi),
    page: PAGE,
    pageSize: PAGE_SIZE,
    sort: vySerialize(fromNullToUndefined(currentSortModel)),
  };

  return useMutation({
    mutationKey: queryKeys.customersOverviewsNew(...Object.values(payload)),
    mutationFn: async () => {
      return customersOverviewsNewQuery(payload);
    },
    ...options,
  });
}
